import React, { useEffect, useState, useRef } from "react";
import { Row, Table, Form } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { PROPOSAL_SET_VALUES } from "../../store/constants/proposalConstants";

export const PaintPricingSection = ({ disable_fields }) => {
  const proposalValues = useSelector((state) => state.proposalValues);
  const dispatch = useDispatch();
  const editablePricingRef = useRef(null);
  const [pricingContent, setPricingContent] = useState(proposalValues?.ai_pricing || "");

  useEffect(() => {
    setPricingContent(proposalValues?.ai_pricing || "");
  }, [proposalValues?.ai_pricing]);

  const handleChange = (evt) => {
    const { name, value: newValue } = evt.target;
    const formattedValue = parseInt(newValue);
    dispatch({
      type: PROPOSAL_SET_VALUES,
      payload: { [name]: formattedValue },
    });
  };

  if (proposalValues?.ai_pricing) {
    return (
      <div
        ref={editablePricingRef}
        style={{ textTransform: "initial", fontSize: "15px", fontFamily: 'Arial' }}
        contentEditable={!disable_fields}
        suppressContentEditableWarning={true}
        dangerouslySetInnerHTML={{ __html: pricingContent }}
        onBlur={() => {
          if (!editablePricingRef.current) return;
          const html = editablePricingRef.current.innerHTML;
          setPricingContent(html);
          dispatch({ type: PROPOSAL_SET_VALUES, payload: { ai_pricing: html } });
        }}
      ></div>
    );
  }

  return (
    <Row>
      <h6 className="fw-bolder">
        PRICING PER MENTIONED SCOPE:
      </h6>
      <Table bordered className="my-4">
        <tbody>
          <tr className="fs-4">
            <th className="text-start w-50">
              <Form.Control
                type="number"
                min="0"
                name="bid_amount"
                className="text-start w-100"
                placeholder={proposalValues?.proposal_template?.includes("Paint") ? "Paint Price" : "Drywall Price"}
                style={{
                  border: "none",
                  background: "none",
                  fontSize: "16px",
                  fontWeight: "bold",
                }}
                disabled={disable_fields ? true : false}
                value={proposalValues?.bid_amount}
                onChange={handleChange}
              />
            </th>
          </tr>
        </tbody>
      </Table>
    </Row>
  );
};

export default PaintPricingSection;
